import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const WebcamIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.92 22C15.94 22 16.67 21 16.34 20.03"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66001 20.03C7.34001 21 8.06001 22 9.08001 22"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.34 20.03L15 16"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16L7.66 20.03"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.07999 22H14.92"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

WebcamIcon.displayName = 'WebcamIcon';
